/**
 * Virtual games & instant betting — `/betting-gaming/virtual-games`
 */
import { VIRTUAL_GAMES_SLUG, virtualGamesDefaultData } from "./virtualGamesData";
import { VirtualGamesArticlesTab, VirtualGamesMediaTab, VirtualGamesOverviewTab } from "./VirtualGamesDesign";

export const virtualGamesModule = {
  slug: VIRTUAL_GAMES_SLUG,
  getDefaultData: () => virtualGamesDefaultData,
  Views: {
    overview: VirtualGamesOverviewTab,
    articles: VirtualGamesArticlesTab,
    media: VirtualGamesMediaTab,
  },
};
